import { formatCurrency } from "../../_utils/pricing";
import "./_price-summary.scss";

/**
 * Reads the SAME memoized totals object usePricingState exposes to the
 * submit payload - display and submit are one source of truth, not two
 * (the old wizard round-tripped its total through 3 pieces of state with a
 * float-diff sync guard; this component just renders whatever the hook
 * already computed).
 */
const PriceSummary = ({ totals, currencySign = "" }) => (
  <div className="price-summary">
    <div className="price-summary__row">
      <span className="price-summary__label">Subtotal</span>
      <span className="price-summary__value">{formatCurrency(totals.subtotal, currencySign)}</span>
    </div>
    <div className="price-summary__row">
      <span className="price-summary__label">After discount</span>
      <span className="price-summary__value">{formatCurrency(totals.discountedAmount, currencySign)}</span>
    </div>
    <div className="price-summary__row">
      <span className="price-summary__label">Tax</span>
      <span className="price-summary__value">{formatCurrency(totals.totalTax, currencySign)}</span>
    </div>
    <div className="price-summary__row price-summary__row--total">
      <span className="price-summary__label">Total</span>
      <span className="price-summary__value">{formatCurrency(totals.totalAmount, currencySign)}</span>
    </div>
  </div>
);

export default PriceSummary;
